import React, { useState, useEffect } from "react"

/**
 * AmsaKattam — South Indian 4×4 horoscope grid (அம்சம் chart)
 * Identical structure to RasiKattam; centre label reads "அம்சம்".
 */

const DEFAULT_GRID = [
    [], [], [], [],
    [], null, null, [],
    [], null, null, [],
    [], [], [], [],
]

const PLANET_ROWS = [
    ["சூ", "சந்", "செவ்", "பு", "குரு"],
    ["சுக்", "சனி", "ரா",  "கே", "ல"],
    ["மா"],
]

const AmsaKattam = ({
    amsaValues,
    setAmsaValues,
    readOnly = false,
    kattamOuterInjectClass,
    kattamInnerInjectclass,
}) => {
    const [grid, setGrid] = useState(
        amsaValues && amsaValues.length === 16 ? amsaValues : DEFAULT_GRID
    )

    // Sync grid when parent loads API data after mount
    useEffect(() => {
        if (amsaValues && amsaValues.length === 16) {
            setGrid(amsaValues)
        }
    }, [amsaValues]) // eslint-disable-line

    const toggle = (cellIdx, planet) => {
        if (grid[cellIdx] === null) return
        const next = grid.map((cell, i) => {
            if (cell === null) return null
            const has = cell.includes(planet)
            if (i === cellIdx) return has ? cell.filter(p => p !== planet) : [...cell, planet]
            return has ? cell.filter(p => p !== planet) : cell
        })
        setGrid(next)
        setAmsaValues?.(next)
    }

    const outerCls = kattamOuterInjectClass || "w-full"
    const cellCls  = kattamInnerInjectclass  || "min-h-[100px]"

    return (
        <div className={`relative border-2 border-black ${outerCls}`}>
            <div className="grid grid-cols-4 grid-rows-4 h-full">
                {grid.map((cell, i) => (
                    <div
                        key={i}
                        className={`${cellCls} ${
                            cell === null
                                ? "border-none"
                                : "border border-black flex flex-col items-center justify-center"
                        }`}
                    >
                        {cell !== null && (
                            readOnly ? (
                                <div className="flex flex-wrap justify-center gap-x-1 gap-y-0.5 p-1">
                                    {cell.map(p => (
                                        <span key={p} className="text-sm font-bold text-black leading-tight">{p}</span>
                                    ))}
                                </div>
                            ) : (
                                <div className="flex flex-col items-center gap-1 p-1">
                                    {PLANET_ROWS.map((row, ri) => (
                                        <div key={ri} className="flex gap-1 flex-wrap justify-center">
                                            {row.map(p => (
                                                <button
                                                    key={p}
                                                    type="button"
                                                    onClick={() => toggle(i, p)}
                                                    className={`text-sm leading-tight px-1.5 py-0.5 border rounded transition-colors
                                                        ${cell.includes(p)
                                                            ? "bg-primeColor text-white border-primeColor font-bold"
                                                            : "bg-white text-black border-gray-300 hover:border-primeColor"
                                                        }`}
                                                >
                                                    {p}
                                                </button>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            )
                        )}
                    </div>
                ))}
            </div>

            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <span className="text-2xl font-bold text-black select-none">அம்சம்</span>
            </div>
        </div>
    )
}

export default AmsaKattam
